export default __webpack_public_path__ + "static/media/card-3-bg-mb@2x.3ea0363d.jpg";